import { Box } from "@chakra-ui/react";

const StationIcon = ({ color = "white", bgColor = "#28292B", ...props }) => {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="20" height="20" rx="10" fill={bgColor} />
        <path
          d="M5.875 16.6562V15.9688L6.90625 15.2812C6.23021 15.2812 5.66016 15.0492 5.19609 14.5852C4.73203 14.1211 4.5 13.551 4.5 12.875V6.34375C4.5 5.39271 4.94115 4.69661 5.82344 4.25547C6.70573 3.81432 8.09792 3.59375 10 3.59375C11.9708 3.59375 13.3802 3.80573 14.2281 4.22969C15.076 4.65365 15.5 5.35833 15.5 6.34375V12.875C15.5 13.551 15.268 14.1211 14.8039 14.5852C14.3398 15.0492 13.7698 15.2812 13.0938 15.2812L14.125 15.9688V16.6562H5.875ZM5.875 9.09375H9.3125V7.03125H5.875V9.09375ZM10.6875 9.09375H14.125V7.03125H10.6875V9.09375ZM7.59375 13.2188C7.88021 13.2188 8.1237 13.1185 8.32422 12.918C8.52474 12.7174 8.625 12.474 8.625 12.1875C8.625 11.901 8.52474 11.6576 8.32422 11.457C8.1237 11.2565 7.88021 11.1562 7.59375 11.1562C7.30729 11.1562 7.0638 11.2565 6.86328 11.457C6.66276 11.6576 6.5625 11.901 6.5625 12.1875C6.5625 12.474 6.66276 12.7174 6.86328 12.918C7.0638 13.1185 7.30729 13.2188 7.59375 13.2188ZM12.4062 13.2188C12.6927 13.2188 12.9362 13.1185 13.1367 12.918C13.3372 12.7174 13.4375 12.474 13.4375 12.1875C13.4375 11.901 13.3372 11.6576 13.1367 11.457C12.9362 11.2565 12.6927 11.1562 12.4062 11.1562C12.1198 11.1562 11.8763 11.2565 11.6758 11.457C11.4753 11.6576 11.375 11.901 11.375 12.1875C11.375 12.474 11.4753 12.7174 11.6758 12.918C11.8763 13.1185 12.1198 13.2188 12.4062 13.2188Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

export default StationIcon;
